<template>
  <div class="switch-container">
    <label class="switch">
      <input
        type="checkbox"
        :checked="value"
        @change="onChange"
      />

      <span class="slider"></span>
    </label>

    <span class="switch-label" @click="onChange">
      {{ label }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ToogleSwitch',

  props: {
    value: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      default: ''
    }
  },

  methods: {
    onChange() {
      this.$emit('input', !this.value)
    }
  }
}
</script>

<style scoped>
.switch-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 22px;
  margin: 0;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 22px;
}

.slider:before {
  content: "";
  position: absolute;
  height: 16px;
  width: 16px;
  left: 3px;
  top: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

.switch input:checked + .slider {
  background-color: #337fd9;
}

.switch input:checked + .slider:before {
  transform: translateX(20px);
}

.switch-label {
  cursor: pointer;
  font-size: 14px;
  color: #333;
  user-select: none;
}
</style>